import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { ILinkProps, Link } from '../../../Link';

type TNewbuildingsLinkProps = Omit<ILinkProps, 'children'>;

export function NewbuildingsLink({ url }: TNewbuildingsLinkProps) {
  return (
    <div className={styles['link']}>
      <Link url={url} target="blank">
        <InlineText2 color="text-main-default">Смотреть все ЖК от застройщика</InlineText2>
      </Link>
    </div>
  );
}
